import { css } from 'emotion'

export const textAlignCenter = css`
  text-align: center;
`
